<template>
    <div class="position-box">
        <div class="head">
            <div class="back-box" @click="goBack"><img class="icon" src="@/assets/icon_back.png" alt="back"></div>
            <div>{{this.$t('langNew2.flzq')}}</div>
        </div>
        <div class="cont-box">
            <ul class="ul" @scroll="listenScroll">
              <li class="li" @click="jump(item)" v-for="(item,index) in flData" :key="index">
                <div class="banner-box"><img class="banner" :src="item.url" alt=""></div>
                <div class="title">{{item.title}}</div>
                <div class="status">{{$t('langNew.jxz')}}</div>
              </li>
            </ul>
            <!-- 暂无数据 -->
            <no-data v-show="isNoData"></no-data>
            <img id="goTop" class="go-top" @click="goTop" v-show="isGoTOP" src="@/assets/top.png" alt="">
        </div>
    </div>
</template>
<script>
import noData from '@/components/noData.vue'
export default {
    name: 'benefits',
    data () {
        return {
          flData: [],
          isNoData: false,
          isGoTOP: false,
          curDataLength: 10,
          page: 1
        }
    },
    mounted(){
        this.getFuli();
    },
    methods: {
      goBack(){
          this.$router.push('/index');
      },
      jump(item){
        var id = item.id;
        if(this.filterHtmlTag(item.content)){
          this.$router.push({path: "/benefitsDetail",query: { id }});
        }
      },
      getFuli(){
		  	let params = {
          token:1,
          page: this.page
        }
        this.$ajax.get('/web/getFuli',{params}).then((res) => {
          let resData = res.data.data;
          if(res.data.code == 0){
            if(resData.length > 0){
              this.flData = this.flData.concat(resData);
              this.curDataLength = resData.length;
            }else{
              this.curDataLength = resData.length;
            }
            if(this.flData.length > 0){
              this.isNoData = false;
            }else{
              this.isNoData = true;
            }
          }else{
            if(this.flData.length > 0){
              this.isNoData = false;
            }else{
              this.isNoData = true;
            }
          }
        }).catch(function(err){
          console.log(err)
        })
      },
      listenScroll(e) {  //监听滚动
        let ele = e.srcElement ? e.srcElement : e.target;
        if(ele.scrollTop > 200){
            this.isGoTOP = true
        }else{
            this.isGoTOP = false
        }
      },
      goTop(){
        $('.ul').animate({scrollTop:'0px'},'slow');
      }
    },
    filters: {

    },
    components:{
      noData
    },
}
</script>
<style scoped>
    .position-box{
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 100%;
        height: auto;
        color: #cecece;
        font-size: .36rem;
        background: url('../assets/element-background.png') no-repeat center center;
        background-size: cover;
        overflow: hidden;
    }
    .center{
        text-align: center;
    }
    .head{
        position: relative;
        height: 1.2rem;
        font-size: .52rem;
        line-height: 1.2rem;
        text-align: center;
    }
    .head .icon{
        position: absolute;
        left: .3rem;
        top: .3rem;
        width: .32rem;
        height: .6rem;
    }
    .cont-box{
        position: absolute;
        left: 0;
        top: 1.2rem;
        bottom: 0;
        width: 100%;
        height: auto;
        padding: 0 .3rem;
        box-sizing: border-box;
        overflow-y: auto;
    }
    .cont-box .li{
      margin: .5rem 0 .2rem 0;
      padding-bottom: .5rem;
      background: #131e30;
      border-radius: .2rem;
    }
    .cont-box .banner{
      width: 100%;
      height: 4.06rem;
      border-radius: .2rem .2rem 0 0;
    }
    .cont-box .title{
      padding: .36rem .5rem .78rem;
      color: #fff;
      font-size: .5rem;
    }
    .cont-box .status{
      display: inline-block;
      margin: 0 .5rem;
      padding: .12rem .5rem;
      color: #fff;
      font-size: .36rem;
      background: #4458ed;
	    border-radius: 0.1rem;
    }
</style>



// WEBPACK FOOTER //
// src/pages/benefits.vue